import React from 'react';
import { Box } from '@common-fe/common-fe';

import LockboxDividingMode from '@/modules/employer/components/Lockbox/LockboxDetails/components/LockboxDividingMode/LockboxDividingMode';
import LockboxChecks from '@/modules/employer/components/Lockbox/LockboxDetails/components/LockboxInfo/LockboxChecks/LockboxChecks';
import LockboxClaims from '@/modules/employer/components/Lockbox/LockboxDetails/components/LockboxInfo/LockboxClaims/LockboxClaims';
import LockboxCurrentStatus from '@/modules/employer/components/Lockbox/LockboxDetails/components/LockboxInfo/LockboxCurrentStatus/LockboxCurrentStatus';
import LockboxEmployees from '@/modules/employer/components/Lockbox/LockboxDetails/components/LockboxInfo/LockboxEmployees/LockboxEmployees';
import { LockboxInformationForm, LockboxRecordForm } from '@/modules/employer/components/Lockbox/LockboxDetails/components/LockboxInfo/LockboxForm';
import LockboxLogChanges from '@/modules/employer/components/Lockbox/LockboxDetails/components/LockboxInfo/LockboxLogChanges/LockboxLogChanges';
import LockboxProcessing from '@/modules/employer/components/Lockbox/LockboxDetails/components/LockboxInfo/LockboxProcessing/LockboxProcessing';

const LockboxInfo = () => (
  <Box pad="spacing12">
    <LockboxRecordForm />
    <LockboxInformationForm />
    <LockboxClaims />
    <LockboxEmployees />
    <LockboxChecks />
    <LockboxDividingMode />
    <LockboxCurrentStatus />
    <LockboxLogChanges />
    <LockboxProcessing />
  </Box>
);

export default LockboxInfo;
